import { useContext } from "react";
import { store } from "../components/Store";

/**
 * Verifica si el usuario actual tiene permisos para crear, editar, y ver una cuenta personal.

 *   Donde `hasPermission` es una función que verifica si el usuario actual
 *   tiene permisos para realizar la acción especificada. El par metro `type`
 *   puede ser `'create'`, `'edit'`, o `'view'`, y se devuelve `true` si el
 *   usuario actual tiene permisos para realizar la acción especificada, o
 *   `false` en caso contrario.
 */
export const usePersonalAccountPermissions = () => {
	const storeContext = useContext(store);
	const globalState = storeContext?.state;
	const isAuth = globalState?.sesionActiva === "SI";
	const canCreateAccounts = globalState?.shouldCreatePersonalAccounts;
	const isAlternativeFlow = globalState?.shouldAssociatePersonalAccountByAlternativeFlow;
	
	const isPersonalAccount = globalState?.isPersonalAccount;

	const permissions = {
		create: !isAuth? true: canCreateAccounts,
		edit: isAuth && isPersonalAccount,
        view: isAuth && isPersonalAccount,
		[`alternative-association-flow`]: isAuth && isAlternativeFlow,
	};

	/**
	 * Verifica si el usuario actual tiene permisos para crear, editar, y ver una cuenta personal.
	 * @param {'create' | 'edit' | 'view' | 'alternative-association-flow'} type -tipo de permiso
	 * @returns {boolean} - Indica si el usuario actual tiene permisos para realizar la acción especificada.
	 */
	const hasPermission = (type) => {
		return permissions[type];
	};

	return {
		hasPermission,
	};
};
